import React from 'react';
import { Theme, Typography, Box } from '@mui/material';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import FlexBox from '../FlexBox';

interface Props {
	title?: string;
	variant: 'success' | 'warning' | 'error' | 'inactive';
	text: string;
	borderStyle?: 'block' | 'round';
}

export const StatusChip = (props: Props) => {
	const classes = useStyles(props);
	return (
		<Box className={classes.wrapper}>
			{!!props.title && (
				<Typography variant="caption" color="textSecondary">
					{props.title}
				</Typography>
			)}
			<FlexBox>
				<div className={classes.statusColor} />
				<Box mr={0.5} />
				<Typography variant="caption">{props.text}</Typography>
			</FlexBox>
		</Box>
	);
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		wrapper: {
			borderRadius: ({ borderStyle = 'block', title }) =>
				!title && borderStyle === 'round' ? 50 : 4,
			border: `1px solid ${theme.palette.border.inputOutline}`,
			padding: theme.spacing(0.75, 1),
		},
		statusColor: {
			backgroundColor: (props: Props) =>
				props.variant === 'success'
					? theme.palette.success.main
					: props.variant === 'warning'
					? theme.palette.warning.main
					: props.variant === 'error'
					? theme.palette.error.main
					: theme.palette.background.secondary,
			borderRadius: 50,
			width: 10,
			height: 10,
		},
	}),
);
